import { Toast } from "antd-mobile";
import axios from "axios";
import {memo, useEffect, useRef, useState} from "react";
import {useLocation, useNavigate } from "react-router-dom";
import {ToastHandler} from "antd-mobile/es/components/toast";
import {getAccessToken, getFaceInfo, putSecondaryInfo, verifyToken} from "@/api/face";
import {LeftOutline} from "antd-mobile-icons";
import './index.scss'

const FaceResult = memo(() => {
  const handler = useRef<ToastHandler>()
  // 使用useLocation钩子获取当前位置对象
  const location = useLocation();
  const navigate = useNavigate();

  // 获取查询参数
  const searchParams = new URLSearchParams(location.search);

  const [verifySuccess, setVerifySuccess] = useState(true);
  // 从查询参数中提取特定的值
  const access_token = searchParams.get('access_token'); // 假设你想获取名为'param'的查询参数
  const verify_token = searchParams.get('verify_token'); // 假设你想获取名为'param'的查询参数
  const encrypted = searchParams.get('encrypted'); // 假设你想获取名为'param'的查询参数
  const type = searchParams.get('type'); // 假设你想获取名为'param'的查询参数
  const [loading, setLoading] = useState(false);

  // 提交法人辅助信息
  const submitSecondaryInfo = async (face: string) => {
    try {
      if (!encrypted) return;
      Toast.show({
        icon: 'loading',
        content: '正在验证人脸...',
      });

      const res = await putSecondaryInfo({
        face,
        encrypted: encrypted.replace(/ /g, '+'), // 将空格转回 +
        type,
      });

      Toast.clear();
      if (res?.code) {
        Toast.show({
          icon: 'fail',
          content: res?.msg || '验证失败, 请重试!',
        });
        setVerifySuccess(false);
      } else {
        Toast.show({
          icon: 'success',
          content: '验证成功!',
        });
        setVerifySuccess(true);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Toast.clear();
      setVerifySuccess(false);
      console.error(err);
    }
  }

  const fetchAccessToken = async () => {
    try {
      Toast.show({
        icon: 'loading',
        content: '即将进入人脸识别...',
      });

      const res = await getAccessToken();

      const { access_token } = res;

      const verifyResult = await verifyToken(access_token);

      const {success, result} = verifyResult;
      if (success) {
        const { verify_token } = result
        const successPage = encodeURIComponent(window.location.origin + '/faceResult?access_token=' + access_token + '&verify_token=' + verify_token + '&encrypted=' + encrypted)
        // const FailPage = encodeURIComponent(window.location.origin + '/faceResult?access_token=' + access_token+ '&encrypted=' + encrypted)
        window.location.href = `https://brain.baidu.com/face/print/?token=${verify_token}&successUrl=${successPage}&failedUrl=${successPage}`
      }
    } catch (err) {
      console.log('访问失败', err);
      console.error(err)
    }
  }

  const fetchFaceInfo = async () => {
    try {
      handler.current = Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
      });

      setLoading(true);
      if (access_token && verify_token) {

        const res = await getFaceInfo(access_token, verify_token);
        const {image} = res.result;
        setVerifySuccess(true);
        submitSecondaryInfo(image);
      }
    } catch (err) {
      setLoading(false);
      setVerifySuccess(false);
      Toast.show({
        icon: 'fail',
        content: '人脸识别失败, 请重试',
      })
      // setTimeout(() => {
      //   navigate(`/preview`);
      // }, 1000);
      console.error(err);
    }
  }

  useEffect(() => {
    fetchFaceInfo();
  }, []);

  return (
      <div className='face-result'>
        <div className='face-result-header'>
          <LeftOutline className='header-back' onClick={() => {
            navigate(-1);
          }} />

          <div className='header-title'>人脸识别</div>

          <div className='header-right'></div>
        </div>

        {
          loading ? (
              <div className='loading-box'>加载中...</div>
          ) : (
              verifySuccess ? (
                  <div className='face-success'>
                    <img src="https://can-open-resource-shenzhenhxjf.oss-cn-shenzhen.aliyuncs.com/public/9cc9dc0f371dcda2306e3c6d2a5b1c3c.png" alt=""/>
                    <div className='success-text'>人脸识别成功</div>
                    <div className='success-tip'>您已完成本次签署</div>
                    <div className='success-button' onClick={() => {
                      if (window.opener) {
                        window.opener.postMessage('close', '*'); // 通知父窗口
                        window.close();
                      } else {
                        window.location.href = 'about:blank'; // 清空页面内容
                        window.close(); // 可能被浏览器拦截
                      }
                    }}>完成</div>
                  </div>
              ) : (
                  <div className='face-error'>
                    <div className='face-success'>
                      <img src="https://can-open-resource-shenzhenhxjf.oss-cn-shenzhen.aliyuncs.com/public/d85c7e5f4cbdd4effa472c98b397f161.png" alt=""/>
                      <div className='success-text'>人脸识别失败</div>
                      <div className='success-tip'>抱歉没有认出你, 请确保是本人操作</div>
                      <div className='success-button' onClick={() => fetchAccessToken()}>重新尝试</div>
                    </div>
                  </div>
              )
          )
        }
      </div>
  )
});

export default FaceResult;